import { gql } from '@apollo/client'
import PropTypes from 'prop-types'
import { artistFragment, artistFragmentPropTypes } from '~/graphql/fragments/artist'

export const eventListFragment = gql`
  fragment eventList on Event {
    id
    slug
    name
    isHighlighted
    imageUrl
    category
    startDate
    endDate
    availableTicketsCount
    status
    artists {
      ...artist
    }
    country {
      code
    }
    uri {
      path
    }
    location {
      id
      name
      city {
        id
        name
      }
    }
    __typename
  }

  ${artistFragment}
`

export const eventListFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  imageUrl: PropTypes.string,
  category: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  availableTicketsCount: PropTypes.number.isRequired,
  status: PropTypes.oneOf(['ACTIVE', 'ON_HOLD', 'EXPIRED', 'CANCELLED']),
  artists: PropTypes.arrayOf(artistFragmentPropTypes).isRequired,
  country: PropTypes.shape({
    code: PropTypes.string,
  }).isRequired,
  uri: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    city: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }),
})
